// extracted by mini-css-extract-plugin
module.exports = {"InlineWrapper":"recaptchaSignage_InlineWrapper__mhVm8"};